import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Button from './Button';
import { getQuestionType } from '../api/common';
import './../style.css'
import './../css/font-icons.css'
import './../css/fonts.css'



const Styles = styled.div`
.visible{
    display: block;
}
.hidden{
    display: none;
}
.question{
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
}

.explanation{
    font-size:12px;
    font-style:italic;
    margin-left: 10px;
}

    .range {
}

input[type=range] {
    -webkit-appearance: none;
    width: 100%;
    margin-top: 30px;
}

input[type=range]:focus {
    outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 10px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 1px 1px 1px #000000;
    background: #3071A9;
    border-radius: 5px;
    border: 1px solid #000000;
}

input[type=range]::-webkit-slider-thumb {
    box-shadow: 1px 1px 1px #000000;
    border: 1px solid #000000;
    height: 30px;
    width: 15px;
    border-radius: 5px;
    background: #FFFFFF;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -11px;
}

input[type=range]:focus::-webkit-slider-runnable-track {
    background: #3071A9;
}

input[type=range]::-moz-range-track {
    width: 100%;
    height: 10px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 1px 1px 1px #000000;
    background: #3071A9;
    border-radius: 5px;
    border: 1px solid #000000;
}
input[type=range]::-moz-range-thumb {
    box-shadow: 1px 1px 1px #000000;
    border: 1px solid #000000;
    height: 30px;
    width: 15px;
    border-radius: 5px;
    background: #FFFFFF;
    cursor: pointer;
}

input[type=range]::-ms-track {
    width: 100%;
    height: 10px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    color: transparent;
}

input[type=range]::-ms-fill-lower {
    background: #3071A9;
    border: 1px solid #000000;
    border-radius: 10px;
    box-shadow: 1px 1px 1px #000000;
}

input[type=range]::-ms-fill-upper {
    background: #3071A9;
    border: 1px solid #000000;
    border-radius: 10px;
    box-shadow: 1px 1px 1px #000000;
}

input[type=range]::-ms-thumb {
    margin-top: 1px;
    box-shadow: 1px 1px 1px #000000;
    border: 1px solid #000000;
    height: 30px;
    width: 15px;
    border-radius: 5px;
    background: #FFFFFF;
    cursor: pointer;
}

input[type=range]:focus::-ms-fill-lower {
    background: #3071A9;
}

input[type=range]:focus::-ms-fill-upper {
    background: #3071A9;
}


#tickmarks {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
}

#tickmarks p {
    position: relative;
    display: flex;
    justify-content: center;
    text-align: center;
    width: 1px;
    background: #D3D3D3;
    height: 10px;
    line-height: 40px;
    margin: 0 0 20px 0;
}
`


var dragSrcEl = null;

function handleDragStart(e) {
    this.style.opacity = '0.4';

    dragSrcEl = this;

    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', this.innerHTML);
}

function handleDragOver(e) {
    if (e.preventDefault) {
        e.preventDefault();
    }

    e.dataTransfer.dropEffect = 'move';

    return false;
}

function handleDragEnter(e) {
    this.classList.add('over');
}

function handleDragLeave(e) {
    this.classList.remove('over');
}

function handleDrop(e) {
    if (e.stopPropagation) {
        e.stopPropagation(); // stops the browser from redirecting.
    }

    if (dragSrcEl != this) {
        dragSrcEl.innerHTML = this.innerHTML;
        this.innerHTML = e.dataTransfer.getData('text/html');
    }

    return false;
}

function handleDragEnd(e) {
    this.style.opacity = '1';

    this.classList.remove('over');
}


const QuizQuestion = props => {
    const { question, goNext, getAnswer } = props;
    const [value, setValue] = useState();
    const [error, setError] = useState();



    useEffect(() => {
        if(question.pass){
            const value = getAnswer(question.originalOrder);
            goNext(value.answer);
            setValue(null);
        }

        if (getQuestionType(question) === 'DRAG_AND_DROP') {
            let items = document.querySelectorAll('.box');
            items.forEach(function (item) {
                item.addEventListener('dragstart', handleDragStart, false);
                item.addEventListener('dragenter', handleDragEnter, false);
                item.addEventListener('dragover', handleDragOver, false);
                item.addEventListener('dragleave', handleDragLeave, false);
                item.addEventListener('drop', handleDrop, false);
                item.addEventListener('dragend', handleDragEnd, false);
            });
        }
    })

    function toggleValue(e) {
        const newValue = value || [];
        const targetValue = e.target.value;
        setValue(newValue.includes(targetValue) ? newValue.filter(v => v !== targetValue) :
            [...newValue, targetValue]);
    }

    function isNumber(n) {
        return (Number(n) === n && n % 1 === 0) ||
            (Number(n) === n && n % 1 !== 0);
    }

    function optionClick() {
        if (getQuestionType(question) === 'DRAG_AND_DROP') {
            const values = [];
            document.querySelectorAll('.box').forEach(b => values.push(b.innerText));
            goNext(values);
            setValue(null);
        } else {
            setError('');
            if (isNumber(value) && !value.toString()) {
                setError('Esta questão é obrigatória');
            } else if (!isNumber(value) && !value) {
                setError('Esta questão é obrigatória');
            } else {
                goNext(value);
                setValue(null);
            }
        }
    }


    function renderQuestion(q) {
        const type = getQuestionType(q);
        switch (type) {
            case 'CHOOSE_ONE':
                return q.options.map((o, index) => {
                    return (
                        <div key={index} className="btn-group btn-group-toggle d-flex box" >
                            <input type="radio" className="required form-control" value={o.value} checked={o.value === value} onChange={() => setValue(o.value)} />
                            <label className="btn btn-default select font-body ls0 nott">{o.title}</label>
                        </div>
                    )
                });
            case 'MULTI_OPTION':
                return q.multiOptions.map((o, index) => {
                    return (
                        <div key={index} className="btn-group btn-group-toggle d-flex" >
                            <input type="checkbox" class="required form-control" name={o.title} value={o.title} checked={value && value.includes(o.title)} onChange={toggleValue} />
                            <label className="btn btn-default select font-body ls0 nott">{o.title}</label>
                        </div>
                    )
                });
            case 'TEXT':
                return (
                    <div className="btn-group btn-group-toggle d-flex" >
                        <textarea rows='5' cols='150' value={value || ''} onChange={e => setValue(e.target.value)} />
                    </div>
                )
            case 'RANGE':
                return (
                    <div  className="col-sm-10" >
                            <input class="" list="tickmarks" value={value || '1'} defaultValue="1" type="range" min="1" max="10" step="1" onChange={e => setValue(e.target.value)} />
                            <datalist id="tickmarks">
                                <p value="1" checked>1</p>
                                <p value="2">2</p>
                                <p value="3">3</p>
                                <p value="4">4</p>
                                <p value="5">5</p>
                                <p value="6">6</p>
                                <p value="7">7</p>
                                <p value="8">8</p>
                                <p value="9">9</p>
                                <p value="10">10</p>
                            </datalist>
                    </div>
                )
            case 'DRAG_AND_DROP': {
                return (
                    <div className="col-sm-12 col-form-label">
                        <p><i>Indicador mais importante</i></p>
                        {q.options.map((o, i) => {
                            return (
                                <div key={i} draggable="true" className="box">{o.title}</div>
                            )
                        })}
                        <p></p>
                        <p><i>Indicador menos importante</i></p>
                    </div>

                )
            }
            default:
                return 'render question undefined'
        }
    }

    return !question || question.pass ? '' : (
        <Styles>
            <div class="container clearfix">
                <div class="form-widget">
                    
                        <form className="row mb-0" action="include/form_forms.php" method="post" encType="multipart/form-data">
                            <div className="form-process">
                                <div className="css3-spinner">
                                    <div className="css3-spinner-scaler"></div>
                                </div>
                            </div>
                            <div className="col-12 form-group" data-toggle="buttons">
                                <div className="row">
                                    <div className="col-sm-12 col-form-label question">
                                        <label htmlFor="titulo-question1">{`${question.order}) ${question.title}`}</label>
                                        {question.explanation && <span className='explanation'>{question.explanation}</span>}
                                    </div>
                                    <div className="col-sm-12">
                                        {renderQuestion(question)}
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div id="processTabs" data-plugin="tabs" className="customjs">
                            <div className="field is-grouped is-grouped-right">
                                <Button caption="Próxima" click={optionClick} />
                                <div className={error ? 'visible' : 'hidden'}>{error}</div>
                            </div>
                        </div>
                    
                </div>
            </div>
        </Styles>
    )
}
export default QuizQuestion;